(async () => {
    const { Core } = await importModule('Core');

    const CN_LOADING = '!loading';
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_BELONGS_FORM = 'form-child';
    /* Optional CSS selector naming the quantity field this button should read.
       Added 2026-09-01 for the "Complete your setup" rows, which each add
       themselves at their own quantity. Everything else omits it and keeps the
       original behaviour of adding exactly one. */
    const ATTR_QTY_FROM = 'qty-from';
    const SEL_ROW = '[data-complementary-item]';
    const SEL_ROW_QTY = '[data-bw-qty]';
    
    customElements.define('product-to-cart', class extends Core {
        elements = {
            button: '[data-to-cart]'
        }
        
        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
            'cart:error':  '_cartUpdateHandler'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
            this._handleClick();
            this._bindQtySnap();
        }

        _handleClick() {
            this.addEventListener('click', this._onClick.bind(this))
        }

        /* TCC 2026-09-04 — PAIRS-ONLY QUANTITIES.
           A cross-sell row can point at a product supplied in pairs, and this
           button adds straight to the cart without any form validation. Snap the
           row's quantity field to its own step on change, so the shopper sees the
           correction before adding; the qty getter snaps again at click time. */
        _bindQtySnap() {
            const $field = this.$qtyField;
            if (!$field) return;
            $field.addEventListener('change', () => {
                $field.value = this._snap($field.value, $field);
            });
        }

        _snap(value, $field) {
            const step = Number($field?.getAttribute('step')) || 1;
            const min = Number($field?.getAttribute('min')) || 1;
            let n = Number(value);
            if (!Number.isFinite(n) || n <= 0) return min;
            if (step > 1) n = Math.round(n / step) * step;
            else n = Math.floor(n);
            return n < min ? min : n;
        }

        _onClick() {
            this.loading = true;
            !this.belongsToForm && this.addToCart(this.cartItem);
        }
 
        addToCart(items) {
            this.publish('cart:add', {
                items
            });
        }

        _cartUpdateHandler() {
            setTimeout(() => {
                this.loading = false
            }, 1500)
        }

        get belongsToForm() {
            return this.hasAttribute(ATTR_BELONGS_FORM)
        }

        get cartItem() {
            return [{ 
                id: +this.getAttribute(ATTR_VARIANT_ID), 
                quantity: this.qty
            }]
        }

        /* Explicit qty-from selector wins; otherwise look for a quantity field in
           the same upsell row. */
        get $qtyField() {
            const selector = this.getAttribute(ATTR_QTY_FROM);
            return selector
                ? document.querySelector(selector)
                : this.closest(SEL_ROW)?.querySelector(SEL_ROW_QTY);
        }

        /* Falls back to 1 whenever no field is present or the value is
           blank/zero/negative, so no caller can add nothing. Where the field
           declares a step (pairs-only products) the value is snapped to it. */
        get qty() {
            const $field = this.$qtyField;
            if (!$field) return 1;
            return this._snap($field.value, $field);
        }
        
        set loading(state) {
            this.$button.classList.toggle(CN_LOADING, state);
        }

        get cartNotificationsEnabled() {
            return window.global.cartNotificationsEnabled;
        }

        set variantId(id) {
            this.setAttribute(ATTR_VARIANT_ID, id)
        }

    })
})();
